import map from "lodash/map"
import { styles } from "constants-lib/styles"
import { updateClicksDL } from "utils-lib/analytics/dataLayer"
import getContentUrl from "utils-lib/getContentUrl"
import "./SocialMediaLinks.scss"

const SocialMediaLinks = ({ links }) => (
  <div className="SocialMediaLinks" data-testid="SocialMediaLinks">
    <ul className="SocialMediaLinks__image-container d-flex pl-0 mb-0">
      {map(links, (item, index) => (
        <>
          {item?.socialLink && (
            <li key={item.socialLink}>
              <a
                data-testid={`LinksButton-${index}`}
                target="_blank"
                rel="noopener noreferrer"
                href={item.socialLink}
                style={{
                  color: styles.footer.quickLinks.color,
                  textDecoration: `none`,
                }}
                onClick={() => {
                  updateClicksDL({
                    ui_element: `MegaNavSectionLink`,
                    object_content: item?.socialIconText ?? "",
                  })
                }}
              >
                {item?.socialIconText && (
                  <span className="sr-only">{`Waste Management on ${item.socialIconText}`}</span>
                )}
                {item?.socialIconMediaPath && (
                  <img
                    className="SocialMediaLinks__image"
                    src={getContentUrl(item.socialIconMediaPath)}
                    alt={item?.iconAltText ?? ""}
                    width="30px"
                    height="30px"
                  />
                )}
              </a>
            </li>
          )}
        </>
      ))}
    </ul>
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// SocialMediaLinks.propTypes = {
//   links: PropTypes.array.isRequired,
// }

export default SocialMediaLinks
